import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Navbar from "../navbar/navbar-desktop.tsx";
import Footer from "../footer/footer.tsx";
import { fetchBistroNwt } from "../../lib/cms.ts";

type MenuCardProps = {
  title: string;
  color: string;
  text?: string;
  pdf?: string | null;
};

function MenuCard({ title, color, text, pdf }: MenuCardProps) {
  if (!pdf) return null;

  return (
    <article
      className="bg-white rounded-2xl shadow-md p-5 md:p-6 flex flex-col gap-4"
      style={{ width: "100%", maxWidth: 560, flex: "0 1 45%" }}
    >
      <h2 className="text-xl md:text-2xl font-serif font-bold" style={{ color }}>
        {title}
      </h2>

      {text ? <p className="text-sm md:text-base text-[#32180d] leading-relaxed">{text}</p> : null}

      <div className="w-full aspect-[3/4] bg-gray-100 rounded-xl overflow-hidden pointer-events-none">
        <iframe
          src={`${pdf}#toolbar=0&navpanes=0&scrollbar=0`}
          title={title}
          className="w-full h-full"
        />
      </div>

      <a
        href={pdf}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-2 text-center bg-[#60260F] text-white py-3 rounded-xl hover:bg-[#7a3419] transition"
      >
        Otevřít soubor
      </a>
    </article>
  );
}

const DenniNabidka: React.FC = () => {
  const [rablinu, setRablinu] = useState<{ pdf: string | null; text: string }>({
    pdf: null,
    text: "",
  });

  useEffect(() => {
    fetchBistroNwt()
      .then((data) => {
        setRablinu({
          pdf: data?.pdfRablinuUrl || null,
          text: data?.textRablinu || "",
        });
      })
      .catch(console.error);
  }, []);

  return (
    <>
      <Helmet>
        <title>Denní nabídka | Hospůdka pod Rablinů</title>
        <meta
          name="description"
          content="Aktuální denní nabídka Hospůdky pod Rablinů."
        />
      </Helmet>

      <div className="relative z-50 isolate">
        <Navbar />
      </div>

      <main className="bg-[#F5E7CC] min-h-screen text-[#32180d]">
        <section className="bg-white py-16 text-center px-6">
          <h1 className="text-2xl md:text-4xl font-bold font-serif">Denní nabídka</h1>
          {/* <p className="mt-4 max-w-3xl mx-auto text-sm md:text-base leading-relaxed">
            Aktuální soubory s denní nabídkou jsou zobrazené vedle sebe. Na menších
            obrazovkách se skládají pod sebe.
          </p> */}
        </section>

        <section className="max-w-7xl mx-auto px-6 py-14">
          <div className="flex flex-col lg:flex-row lg:justify-center gap-8 lg:gap-[5%] items-stretch">
            <MenuCard
              title="Hospůdka pod Rablinů"
              color="#d97706"
              text={rablinu.text}
              pdf={rablinu.pdf}
            />
          </div>
        </section>

        <div className="[all:unset] block">
          <Footer />
        </div>
      </main>
    </>
  );
};

export default DenniNabidka;
